import { render } from "./manage_questions.html?vue&type=template&id=ba218594&scoped=true&external"
import script from "./manage_questions.js?vue&type=script&lang=js&external"
export * from "./manage_questions.js?vue&type=script&lang=js&external"

import "./ManageQuestions.vue?vue&type=style&index=0&id=ba218594&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba218594"]])

export default __exports__